module.exports = __webpack_public_path__ + "static/img/14.35138df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/eng/14.png
// module id = i08p
// module chunks = 0